import { render } from "./DeliveryAddAddress.vue?vue&type=template&id=1af06253"
import script from "./DeliveryAddAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddAddress.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__